export function Item4() {
  return (
    <>
      <p className="text-lg font-medium text-blue-200 mt-6 underline">
        Assessoria para credores:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Fornecemos suporte integral aos credores para definição da melhor
        estratégia de negociação com empresas em situação de insolvência, além
        de assessoria prévia ao pedido de recuperação judicial, extrajudicial ou
        falência, visando a melhoria da posição do cliente perante o devedor.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Atuamos com análise financeira e de riscos envolvidos em propostas de
        pagamento, planos de recuperação judicial e planos de alienação de
        ativos.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-6 underline">
        Aquisição de créditos:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Realizamos a aquisição de créditos sujeitos a recuperações judiciais,
        extrajudiciais e falências, além daqueles perante empresas em situação
        de pré-insolvência.
      </p>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Também oferecemos assessoria para cessão de créditos, inclusive por meio
        da nossa ampla rede de players de destacada atuação no mercado.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-6 underline">
        Aquisição de ativos:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-6">
        Identificamos oportunidades de investimento em ativos de empresas em
        situação de insolvência - Unidades de Produção Isolada - UPIs, unidades
        de negócio, imóveis, veículos, equipamentos, dentre outros. Analisamos
        os riscos e trabalhamos para que a aquisição seja realizada com a maior
        segurança possível para o cliente.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-6 underline">
        DIP Financing:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Assessoria para financiamento de empresas em recuperação judicial - DIP
        Financing, auxiliando investidores e devedores no entendimento e
        estruturação das operações.
      </p>

      <p className="text-lg font-medium text-blue-200 mt-4 underline">
        Parcerias estratégicas:
      </p>
      <p className="text-lg font-medium text-blue-200 mt-4">
        Trabalhamos em colaboração com os melhores escritórios de advocacia e
        assistentes técnicos do mercado para garantir o sucesso de nossos
        clientes.
      </p>
    </>
  );
}
